<template>
  <transition 
  enter-active-class="fadeIn"
  leave-active-class="fadeOut"
  name="fade">
	  <div 
    v-bind:style="{ top: top + 'px', left: left + maxWidth + 'px', maxWidth: maxWidth + 'px' }"
    v-if="active" v-on:click="close" ref="tooltip" v-bind:class="{ tooptip: true }"> 
	 	   {{ message }} 
	     <div class="close"><i class="fa fa-times"></i></div>
	  </div>
  </transition>

</template>

<script>

export default {
  data: function(){ 
    return{
      left: 0,
      top: 0,
      maxWidth: 211,
    	active: false,
    }
  },

  props: ['trigger', 'message', 'identifier'],

  computed: {

  	loading(){
  	  return this.$store.state.loading[this.identifier];
  	},

  },


  methods: {

  	show(){

      // Get and set position
      var position = $(this.identifier).offset()

      this.left = position.left + 10
      this.top = position.top + 25

      // Active
  		this.active = true;
  	},

  	close(){
  		this.active = false;
  	}

  },

  mounted(){

  	var self = this;

  	var elementToReactTo = $(self.identifier);

  	if(self.trigger == "click"){
  		elementToReactTo.on("click", function(){
  			self.show();
  		})
  	}

  	if(self.trigger == "hover"){
  		elementToReactTo.on("mouseover", function(){
  			self.show();
  		})
  	}


  }

}
</script>

<style>

.tooptip{
	position: absolute;
    padding: 12px;
    background: black;
    color: white;
    z-index: 9;
    font-size: 11px;
    border-radius: 3px;

    .close{
    	position: absolute;
	    right: 4px;
	    top: -2px;
	    cursor: pointer;
    }
}




</style>



// WEBPACK FOOTER //
// Tooltip.vue?4bc0383f